/* eslint-disable import/prefer-default-export */
import { Conversation } from '@centecomm/portal-service';
import { conversationsActions } from '../..';
import { Streams } from '../../../Types';
import { ConversationEventTypes, ConversationEnded } from '../../../Types/Conversations/Events';
import { ConversationEndedWrappedEvent } from '../../../Types/Conversations/WrappedEvents';
import { ConversationsActionTypes } from '../../Conversations/actions';

export const conversationEndedHandler = (
    { conversationId, metadata }: Streams.ConversationEndedStreamMessage,
    conversations: Record<number, Conversation>,
    dispatch,
): void => {
    const { eventDate } = metadata;

    if (conversations.hasOwnProperty(conversationId)) {
        dispatch({
            type: conversationsActions.SET_CONVERSATION_INACTIVE,
            payload: conversationId,
        } as ConversationsActionTypes);

        dispatch({
            type: conversationsActions.ADD_EVENT_TO_CONVERSATION,
            payload: {
                conversationId: conversationId,
                event: {
                    type: ConversationEventTypes.ConversationEnded,
                    event: {
                        conversationId: conversationId,
                        metadata: {
                            eventDate: eventDate,
                        },
                    } as ConversationEnded,
                } as ConversationEndedWrappedEvent,
            },
        } as ConversationsActionTypes);
    }
};
